// @flow
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import {
    aiModelsLoaded,
    aiModelsRequestFailed
} from '../actions';
import {fetchJSON} from "../../helpers/api";

/**
 * Watch load AI translation models request
 *
 * This is a supplementary list for a settings dropdown, so failures are
 * surfaced inline (via aiModelsRequestFailed) instead of redirecting away
 * from the settings page.
 * @returns {IterableIterator<ForkEffect>}
 */
export function* watchAiModelsLoad(): any {
    yield takeEvery('AI_MODELS_LOAD', function*() {
        try {
            const options = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            };

            const response = yield call(fetchJSON, '/ai-translations/models', options);
            yield put(aiModelsLoaded(response));
        } catch (error) {
            console.warn(error);
            yield put(aiModelsRequestFailed());
        }
    });
}

function* AiModelsSaga(): any {
    yield all([
        fork(watchAiModelsLoad),
    ]);
}

export default AiModelsSaga;
